import { genreTranslations } from './genres.js';
export function slugify(value) {
  const normalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’'"`]/g, '');
  const ascii = normalized.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
  if (ascii) return ascii;
  const letters = normalized.replace(/[^\p{L}\p{N}]+/gu, '');
  return letters ? `unicode-${Array.from(letters, (character) => character.codePointAt(0).toString(16)).join('-')}` : '';
}

export function canonicalGenreSlug(slug) {
  const entry = Object.entries(genreTranslations).find(([from]) => slugify(from) === slug);
  return entry ? slugify(entry[1]) : slug;
}

export function albumPath(album) {
  return `/album/${album.id}/${album.slug}`;
}

export function entityPath(type, name) {
  return `/${type}/${slugify(name)}`;
}

export function parseAppPath(pathname) {
  const album = pathname.match(/^\/album\/([a-f0-9]{16})(?:\/[^/]*)?\/?$/);
  if (album) return { page: 'album', id: album[1] };
  const entity = pathname.match(/^\/(artist|label|genre|quality)\/([^/]+)\/?$/);
  if (entity) return { page: 'entity', entityType: entity[1], slug: entity[1] === 'genre' ? canonicalGenreSlug(entity[2]) : entity[2] };
  if (pathname === '/' || pathname === '') return { page: 'explore' };
  if (pathname === '/collection' || pathname === '/collection/') return { page: 'collection' };
  if (pathname === '/pick' || pathname === '/pick/') return { page: 'pick' };
  if (pathname === '/stats' || pathname === '/stats/') return { page: 'stats' };
  return { page: 'not-found' };
}

